/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadCommentCount } from './LeadCommentCount';
import {
    LeadCommentCountFromJSON,
    LeadCommentCountFromJSONTyped,
    LeadCommentCountToJSON,
    LeadCommentCountToJSONTyped,
} from './LeadCommentCount';

/**
 * 
 * @export
 * @interface FindLeadsBatchWithCommentCounts200Response
 */
export interface FindLeadsBatchWithCommentCounts200Response {
    /**
     * 
     */
    data?: Array<LeadCommentCount>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithCommentCounts200Response interface.
 */
export function instanceOfFindLeadsBatchWithCommentCounts200Response(value: object): value is FindLeadsBatchWithCommentCounts200Response {
    return true;
}

export function FindLeadsBatchWithCommentCounts200ResponseFromJSON(json: any): FindLeadsBatchWithCommentCounts200Response {
    return FindLeadsBatchWithCommentCounts200ResponseFromJSONTyped(json, false);
}

export function FindLeadsBatchWithCommentCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithCommentCounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(LeadCommentCountFromJSON)),
    };
}

export function FindLeadsBatchWithCommentCounts200ResponseToJSON(json: any): FindLeadsBatchWithCommentCounts200Response {
    return FindLeadsBatchWithCommentCounts200ResponseToJSONTyped(json, false);
}

export function FindLeadsBatchWithCommentCounts200ResponseToJSONTyped(value?: FindLeadsBatchWithCommentCounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(LeadCommentCountToJSON)),
    };
}

